import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { classNames } from 'primereact/utils'
import { Password } from "primereact/password"
import { InputText } from 'primereact/inputtext'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import * as auth from "infra/localStorage.js"
import server from 'infra/server'
import { getMessagesFromError } from 'helper/error'
import { Message } from 'primereact/message'
import { Tag } from 'primereact/tag'
import { Avatar } from 'primereact/avatar'

export default function AdicionaBaseExtra() {

    const { state } = useLocation()
    const [message, setMessage] = useState({})
    const navigate = useNavigate()
    const toast = useRef(null)
    const { msgRegistered } = state || ""
    const [baseDados, setBaseDados] = useState([])
    const storageData = auth.getData()
    const [logado, setLogado] = useState(storageData.token != '')

    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff'
        return () => {
            document.body.style.backgroundColor = ''
        }
    }, [])

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {

        if (msgRegistered && msgRegistered.length > 0) {
            setMessage(msgRegistered)
        }

        buscaBases()

    }, [logado])


    const form = useForm()
    const errors = form.formState.errors


    const onSubmit = (data) => {
    }

    const buscaBases = () => {

        if (!logado) return

        server().get('basedados')
            .then((response) => {
                setBaseDados(response.data)
            }).catch(e => {

                if (e?.response?.data?.errors) {
                    if (e.response.data.errors.length > 0) {
                        if (e.response.data.errors[0].message.includes('Unauthorized access')) {
                            auth.deleteToken()
                        }

                    }
                }
            })
    }

    const btnLoginOnClick = (e) => {

        const data = form.getValues()
        setMessage({})

        if (data.email && data.password) {

            toast.current.show({ detail: 'Fazendo login...' })

            server().post('login', {
                "loginUsu": data.email,
                "password": data.password
            }
            ).then((response) => {

                // Logou

                storageData.token = response.data.token
                auth.setData(storageData)

                // Busca [Base] e [Empresa]
                server().get('sessaoinfo').then(async (response) => {

                    const dataInfo = response.data[0]

                    storageData.usuario.nome_usu = dataInfo.nome_usu
                    storageData.usuario.email_usu = dataInfo.login_usu
                    storageData.base.codnum_bad = dataInfo.codnum_bad
                    storageData.base.descricao_bad = dataInfo.descricao_bad
                    storageData.empresa.codigo_emp = dataInfo.cod_emp_ten_log_ses
                    storageData.bucketPath = dataInfo.bucketPath
                    auth.setData(storageData)

                    setLogado(true)

                    toast.current.show({ detail: 'Buscando bases...' })
                    buscaBases()

                    toast.current.clear()

                })

            }).catch(err => {
                toast.current.clear()
                const message = getMessagesFromError({ err, alt: 'Erro desconhecido ao fazer login!' })
                setMessage({ severity: 'error', message })
            })

        }
    }
    const btnAdicionarOnClick = (data) => {

        console.log("Adicionando base....", data)

        setMessage({})

        server().post('basedadosextra', {
            "descricao_bad": data.descricaoBad,
            "outrocoisa": "nada"
        }).then((response) => {

            setMessage({ severity: 'success', message: response.data })
            buscaBases()

        }).catch(err => {
            toast.current.clear()
            const message = getMessagesFromError({ err, alt: 'Problemas ao adicionar a base de dados!' })
            setMessage({ severity: 'error', message })
        })

    }

    const logout = () => {
        if (!logado) return
        server().post('/logout')
            .then((response) => {
                auth.deleteToken()
                setLogado(false)
            })
    }

    const help = `Para adicionar novas bases de empresas as anteriores
    devem terem sidas usadas!`

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>
    }

    const compAdicionar = (e) => {
        return (
            <div >
                <div>
                    <h3>Você tem essas bases:</h3>
                    <div className='flex flex-column align-items-start gap-2'>
                        {baseDados.map((e, index) => {
                            return <Tag key={index} className='pl-3 pr-3 gap-2' icon="pi pi-database" severity="success" value={e.descricao_bad}></Tag>
                        })}
                    </div>
                </div>
                <Controller
                    name="descricaoBad"
                    control={form.control}
                    rules={{ required: 'Obrigatório' }}
                    defaultValue=""
                    render={({ field, fieldState }) => (
                        <div className='flex flex-column mt-4'>
                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricaoBad })}>Nome da base: </label>
                            <InputText id={field.name} {...field} placeholder='Ex. Grupo 2' inputMode="text"
                                className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                autoComplete="off" />
                            {getFormErrorMessage(field.name)}
                        </div>
                    )}
                />

                <Button id='btnAddExtraBase' label="Adicionar nova base" type="submit" icon={loading ? "pi pi-spin pi-cog" : "pi pi pi-database"}
                    onClick={form.handleSubmit(btnAdicionarOnClick)}
                    className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl mt-2"
                />

                <div className="md:w-20rem mt-2 text-sm" style={{ fontStyle: 'italic' }}>
                    {help}
                </div>

                {logado && <div className='mt-3'>
                    <Link onClick={e => {
                        e.preventDefault()
                        logout()
                    }}
                        className="text-logo-main no-underline"
                    >
                        Usar outra conta
                    </Link>
                </div>
                }
            </div>
        )
    }

    const compLogin = e => {
        return (
            <div className='flex flex-column'>
                <Controller
                    name="email"
                    control={form.control}
                    rules={{ required: 'E-mail' }}
                    defaultValue=""
                    render={({ field, fieldState }) => (
                        <>
                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.email })}>
                            </label>
                            <InputText
                                id={field.name}
                                {...field}
                                placeholder='E-mail'
                                inputMode="email"
                                className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                autoComplete="on"
                            />
                            {getFormErrorMessage(field.name)}
                        </>
                    )}
                />
                <Controller
                    name="password"
                    control={form.control}
                    rules={{ required: 'A senha é obrigatória' }}
                    defaultValue=""
                    render={({ field, fieldState }) => (
                        <>
                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })} />

                            <Password
                                inputId={field.name}
                                {...field}
                                placeholder='Senha'
                                inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                className={classNames("", { 'p-invalid': fieldState.error })}
                                pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                feedback={false}
                                autoComplete="on"
                                toggleMask={true}
                            />
                            {getFormErrorMessage(field.name)}
                        </>
                    )}
                />
                {/* <Button label="Login" type="submit" icon="pi pi-check" onClick={btnLoginOnClick} /> */}

                {/* Botão */}
                <Button id='btnConfirmar' label="Confirmar" type="submit" icon={loading ? "pi pi-spin pi-cog" : ""}
                    className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl mt-2"
                    onClick={form.handleSubmit(btnLoginOnClick)}
                />

                {/* Links adicionais */}
                <div className="text-right mt-4">
                    <Link id='login' to="/login" className="text-logo-main no-underline">Login</Link>
                </div>

                {/* <Link to={'/login'} className="flex mt-2 text-sm" onClick={e => {
                    e.preventDefault()
                    navigate('/login')
                }}>
                    Voltar para o login
                </Link> */}

            </div>
        )
    }

    const compAvatar = () => {
        if (!logado) return ''
        return (
            <div>
                <div className='flex flex-row align-items-center gap-2'>
                    <Avatar label={storageData.usuario.nome_usu[0]} shape="circle" size="large" className="flex" />
                    <div className='flex flex-column gap-1'>
                        <span className='font-bold'>{storageData.usuario.nome_usu}</span>
                        <span className=''>{storageData.usuario.email_usu}</span>
                    </div>
                </div>
                <Link to={'/login'} className="flex mt-2 text-sm m-1" onClick={e => {
                    e.preventDefault()
                    logout()
                    navigate('/login')
                }}>Sair</Link>
            </div>
        )
    }

    return (

        <div className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0" >
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center z-1`}>

                {/* Cabeçalho */}
                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>
                {/* Formulário */}
                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">
                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-4">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div className='ml-2 font-light'>Adicionar bases de empresas</div>
                        </h2>
                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column align-items-left gap-2">

                            {compAvatar()}
                            {!storageData.token && compLogin()}
                            {storageData.token && compAdicionar()}
                            {message.message &&
                                <Message id='message' className="md:w-20rem mt-2 text-sm" style={{ fontStyle: 'italic' }} severity={message.severity} text={message.message} />
                            }
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
